import { Link } from "react-router-dom";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import { COLOR_VALUES } from "shared/config/colors";
import { SPACING_VALUES } from "shared/config/spacing";
import styled from "styled-components";

export const StyledLinked = styled(Link)`
    flex: 0 0 31%;
    max-width: 426px;

    &:hover {
        color: unset;
        text-decoration: none;
    }
`;

export const BIDashBoardCard = styled(VStack)`
    min-width: 10rem;
    width: 100%;
    height: 100%;
    min-height: 120px;
    background: ${COLOR_VALUES.White};
    padding: 16px 8px 24px 16px;
    border: 1px solid ${COLOR_VALUES.Gray_6};
    border-radius: 4px;
    &:hover {
        border-color: ${COLOR_VALUES.Gray_4};
    }
`;

export const Wrapper = styled(VStack)`
    width:100%;
    border: 1px dashed ${COLOR_VALUES.Gray_5};
    border-radius: 4px;
    padding: ${SPACING_VALUES.Two};
`;

export const StyledBlock = styled.div`
    display: inline-block;
`;

export const StyledLinkText = styled(Text)`
    cursor:pointer;
`;
